import { AdapterFactory } from '../AdapterFactory';

export const inspectionService = AdapterFactory.getInspectionAdapter();
